<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormPlandeVenta" role="form" method="post" autocomplete="off" onSubmit="return false">
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="TipoPlan">Tipo Plan</label>
							<select v-model="objPlandeVenta.TipoPlan" class="form-control form-select" id="TipoPlan">
								<option value="">Seleccione una opción</option>
								<option value="MENSUAL">MENSUAL</option>
								<option value="BIMESTRAL">BIMESTRAL</option>
								<option value="TRIMESTRAL">TRIMESTRAL</option>
								<option value="CUATRIMESTRAL">CUATRIMESTRAL</option>
								<option value="SEMESTRAL">SEMESTRAL</option>
							</select>
							<CValidation v-if="this.errorvalidacion.TipoPlan" :Mensaje="'*'+errorvalidacion.TipoPlan[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Anio">Año</label>
							<select v-model="objPlandeVenta.Anio" class="form-control form-select" id="Anio">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item,index) in ListaAnios" :key="index" :value="item">{{item}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Anio" :Mensaje="'*'+errorvalidacion.Anio[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Monto">Monto</label>
							<input type="text" v-model="objPlandeVenta.Monto" @input="$number_decimal($event,objPlandeVenta,'Monto')" class="form-control" id="Monto" placeholder="Ingresar Monto" />
							<CValidation v-if="this.errorvalidacion.Monto" :Mensaje="'*'+errorvalidacion.Monto[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import moment from 'moment';

export default {
    name: 'FormPlandeVenta',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objPlandeVenta: {
				IdPlanDeVentas: 0,
				FechaRegistro: '',
				TipoPlan: '',
				Anio: 0,
				Monto: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			ListaAnios: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objPlandeVenta.IdPlanDeVentas == 0) {
				await this.$http.post(
					'plandeVentas',this.objPlandeVenta
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'plandeVentas/'+this.objPlandeVenta.IdPlanDeVentas,
					this.objPlandeVenta
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "plandeVentas/"+this.objPlandeVenta.IdPlanDeVentas
            ).then((res) => {
                this.objPlandeVenta = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objPlandeVenta.Fecha.replace(/-/g,'\/');
                this.objPlandeVenta.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objPlandeVenta = {
				IdPlanDeVentas: 0,
				FechaRegistro: '',
				TipoPlan: '',
				Anio: 0,
				Monto: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
		SetearAnios()
		{
			let anioBase = 2023;
			let anioActual = moment(new Date()).format('YYYY');

			for(let i = anioBase; i<=(parseInt(anioActual)+1);i++){
				this.ListaAnios.push(i);
			}
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
			this.SetearAnios();
                
            if (Id!='') 
            {
                this.objPlandeVenta.IdPlanDeVentas = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
